module.exports = __webpack_public_path__ + "img/logo_fotor.25f1f92.png";